import * as actionTypes from "./actionTypes";
import { trackSimpleEvent } from "../../helpers/reduxBeacon";

const gaEventsMap = {
  ...trackSimpleEvent(actionTypes.ADD_PRODUCT),
  ...trackSimpleEvent(actionTypes.REMOVE_PRODUCT)
};

export default gaEventsMap;
